import React from "react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_creative-freedom-ai-1/artifacts/xmezblsi_Logo.jpeg";

/**
 * Branded AI Receptionist phone mockup.
 * Fully CSS-driven. No JS animation libraries. Loops gently every 12 seconds.
 *
 * The mockup walks visitors through one complete AI Receptionist moment:
 *   incoming call → live waveform → appointment booked → lead qualified → CRM synced
 * All visuals use the Freedom By AI Design brand: pure black, gold accent,
 * Cormorant Garamond display, Manrope text.
 */
export default function PhoneMockup() {
  return (
    <div className="phone-wrap" data-testid="phone-mockup">
      <div className="phone-glow" aria-hidden="true" />
      <div className="phone-frame">
        <div className="phone-notch" aria-hidden="true" />
        <div className="phone-screen">
          {/* Status bar */}
          <div className="phone-status">
            <span>9:41</span>
            <div className="status-icons">
              <span className="bar" />
              <span className="bar" />
              <span className="bar" />
              <span className="bar tall" />
              <span className="batt" />
            </div>
          </div>

          {/* Brand */}
          <div className="phone-brand">
            <img src={LOGO_URL} alt="Freedom By AI Design" />
            <div className="phone-brand-status">
              <span className="status-dot" />
              AI Receptionist · Live
            </div>
          </div>

          {/* Live call card */}
          <div className="phone-call-card">
            <div className="call-row">
              <div>
                <div className="call-from">Incoming Call</div>
                <div className="call-number">(720) 555 · 0142</div>
              </div>
              <div className="call-tag">Denver, CO</div>
            </div>
            <div className="waveform" aria-hidden="true">
              {Array.from({ length: 24 }).map((_, i) => (
                <span key={`wave-bar-${i}`} style={{ animationDelay: `${i * 0.06}s` }} />
              ))}
            </div>
            <div className="call-status">
              <span className="pulse-dot" />
              AI Receptionist · Answering
            </div>
          </div>

          {/* Notifications stack */}
          <div className="phone-notifs">
            <div className="notif notif-1">
              <div className="notif-icon">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="5" width="18" height="16" rx="2" />
                  <path d="M16 3v4M8 3v4M3 10h18" />
                </svg>
              </div>
              <div className="notif-text">
                <div className="notif-title">Appointment Booked</div>
                <div className="notif-sub">Tomorrow · 2:30 PM</div>
              </div>
              <div className="notif-check">✓</div>
            </div>

            <div className="notif notif-2">
              <div className="notif-icon">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 12l2 2 4-4" />
                  <circle cx="12" cy="12" r="9" />
                </svg>
              </div>
              <div className="notif-text">
                <div className="notif-title">Lead Qualified</div>
                <div className="notif-sub">High intent · $12K value</div>
              </div>
              <div className="notif-check">✓</div>
            </div>

            <div className="notif notif-3">
              <div className="notif-icon">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M3 12a9 9 0 0 1 15-6.7L21 8" />
                  <path d="M21 3v5h-5" />
                  <path d="M21 12a9 9 0 0 1-15 6.7L3 16" />
                  <path d="M3 21v-5h5" />
                </svg>
              </div>
              <div className="notif-text">
                <div className="notif-title">CRM Synced</div>
                <div className="notif-sub">GrowthHub365 · Updated</div>
              </div>
              <div className="notif-check">✓</div>
            </div>
          </div>

          {/* Footer bar */}
          <div className="phone-footer">
            <span className="phone-footer-dot" />
            Working 24 / 7 · so you don't have to
          </div>
        </div>
      </div>
    </div>
  );
}
